// File: frontend/src/components/pages/home/TrustedCompanies.js

import React from 'react';
import { useLanguage } from '../../../hooks/useLanguage';
import styles from './TrustedCompanies.module.css';

const TrustedCompanies = () => {
  const { t } = useLanguage();

  const companies = [
    'State Farm', 'Geico', 'Progressive', 'Allstate', 'USAA',
    'Liberty Mutual', 'Nationwide', 'Travelers', 'MetLife', 'Chubb',
    'Intact Insurance', 'Desjardins', 'Aviva Canada', 'TD Insurance',
    'Wawanesa', 'Co-operators', 'Belairdirect', 'Sonnet', 'CAA Insurance',
    'RBC Insurance'
  ];

  const duplicated = [...companies, ...companies];

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <p className={styles.label}>
          {t('trusted.label', 'Works with policies from 50+ insurers including')}
        </p>

        <div className={styles.track}>
          <div className={styles.scroll}>
            {duplicated.map((company, index) => (
              <span key={`${company}-${index}`} className={styles.company}>
                {company}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedCompanies;